import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function Questionario({ match }) {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handleSubmit(data) {
    try {
      setCarregar(true);
      const { id } = match.params;
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        pergunta: Yup.string().required('Preencha o campo pergunta'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/produto/${id}/perguntas`, {
        name: data.name,
        pergunta: data.pergunta,
      });

      toast.success('Pergunta cadastrado com sucesso');
      history.push(`/produto-edit/${id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o pergunta verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Questionário</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handleSubmit} autoComplete="off">
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input icon="MdPerson" label="Pergunta" name="pergunta" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

Questionario.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
